import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ICampaignContactableDetails,
  ICampaignDraftDetails,
  ICampaignInitialDetails,
  ICurrencyList,
  IFaqDetails,
  IFolderDetails,
  ILocationResponse,
  ISaveAndContinueResponse,
  IWhatsAppCampaign,
  TRequestStatus,
} from "../../types/campaign.types";
import { MAX_COUNT } from "../../utils/whatsAppUtils";

const initialState: IWhatsAppCampaign = {
  initialDetails: {
    jobLocations: null,
    jobTitle: null,
    maxExp: null,
    minExp: null,
    maxSalary: null,
    minSalary: null,
    currency:null
  },
  contactableDetails: {
    contactableCount: null,
    folderId: null,
    notContactableCount: null,
    totalCount: null,
    profileCount: MAX_COUNT,
  },
  draftDetails: null,
  faqDetails: [],
  jobLocations: null,
  currency: [],
  saveAndContinueResponse: null,
  folders: [],

  // fetch folders
  fetchFoldersStatus: "idle"
};

const whatsAppCampaignSlice = createSlice({
  name: "whatsAppCampaign",
  initialState,
  reducers: {
    setCampaignInitialDetails(
      state,
      action: PayloadAction<{
        campaignInitialDetails: ICampaignInitialDetails;
      }>
    ) {
      state.initialDetails = action.payload.campaignInitialDetails;
    },

    setCampaignContactableDetails(
      state,
      action: PayloadAction<{
        contactableDetails: ICampaignContactableDetails;
      }>
    ) {
      state.contactableDetails = action.payload.contactableDetails;
    },

    setCampaignDraftDetails(
      state,
      action: PayloadAction<{
        draftDetails: ICampaignDraftDetails;
      }>
    ) {
      state.draftDetails = action.payload.draftDetails;
    },

    setCampaignFaqDetails(
      state,
      action: PayloadAction<{
        faqDetails: IFaqDetails[];
      }>
    ) {
      state.faqDetails = action.payload.faqDetails;
    },

    setFolders(
      state,
      action: PayloadAction<{
        folders: IFolderDetails[];
      }>
    ) {
      state.folders = action.payload.folders;
    },

    setFoldersStatus(
      state,
      action: PayloadAction<{
        status: TRequestStatus;
      }>
    ) {
      state.fetchFoldersStatus = action.payload.status;
    },

    setJobLocationsDetails(
      state,
      action: PayloadAction<{
        jobLocations: ILocationResponse;
      }>
    ) {
      state.jobLocations = action.payload.jobLocations;
    },

    setCurrencyList(
      state,
      action: PayloadAction<{
        currency: ICurrencyList[];
      }>
    ) {
      state.currency = action.payload.currency;
    },

    setSaveAndContinueResponse(
      state,
      action: PayloadAction<{
        response: ISaveAndContinueResponse | null;
      }>
    ) {
      const response = action.payload.response;
      if (response) {
        state.saveAndContinueResponse = action.payload.response;
      }
    },
  },
});

const whatsAppCampaignReducer = whatsAppCampaignSlice.reducer;
const whatsAppCampaignSliceActions = whatsAppCampaignSlice.actions;

export { whatsAppCampaignSliceActions };
export default whatsAppCampaignReducer;
